export default "__VITE_ASSET__B72n_WPO__"